
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReactionsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reactions"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thumbsUp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thumbsDown"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"laugh"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hooray"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"confused"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"heart"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":115}};
    doc.loc.source = {"body":"fragment ReactionsFields on Reactions {\n  totalCount\n  thumbsUp\n  thumbsDown\n  laugh\n  hooray\n  confused\n  heart\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
